import CategoryHeading from "../components/CategoryHeading";
import MonsterCard from "../components/MonsterCard";
import monsterList from "../data/monsters.json";
import { Monster } from "../types";
import { style } from "../style";


export default function Monsters()
{
    const categoryList: string[] = ["broken", "decay", "working", "repaired", "original", "improved"];
    const monsterData: Monster[] = monsterList;

    function renderCategories(monsterData: Monster[])
    {
        let categoryComplete = [];

        for (let h = 0; h < categoryList.length; h++)
        {
            let category = categoryList[h];
            const monsterGroup: Monster[] = [];
            for (let i = 0; i < monsterData.length; i++)
            {
                const monster = monsterData[i];
                if (monster.category === category)
                {
                    monsterGroup.push(monster);
                }
            }
            const cardCollection: React.ReactElement[] = [];
            for (let i = 0; i < monsterGroup.length; i++)
            {
                if ((i === 0) && (monsterGroup.length > 0))
                {
                    cardCollection.push(<CategoryHeading category={monsterGroup[i].category} />);
                }

                const cardElement = (
                    <MonsterCard
                        key={monsterGroup[i].id}
                        id={monsterGroup[i].id}
                        name={monsterGroup[i].name}
                        stage={monsterGroup[i].stage}
                        type={monsterGroup[i].type}
                        origin={monsterGroup[i].origin}
                        location={monsterGroup[i].location}
                        category={monsterGroup[i].category}
                        image={monsterGroup[i].image}
                        description={monsterGroup[i].description}
                        color={monsterGroup[i].color}
                    />
                );
                cardCollection.push(cardElement);
            }
            categoryComplete.push(cardCollection);
        }
        return categoryComplete;
    }

    return (
        <>
            <h1 className={style.h1}>Monsters</h1>
            <div className="flex flex-col gap-24">
                {renderCategories(monsterData)}
            </div>
        </>
    );
}